import { makeStyles } from "@material-ui/core";

export const moveDealToPipelineStyle = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:focus-visible": {
      outline: "none",
    },
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    // border: "1px solid #000",
    boxShadow: theme.shadows[5],
    borderRadius: theme.spacing(0.5),
    width: 800,
    // height: "98vh",
    "&:focus-visible": {
      outline: "none",
    },
  },
  modalHeader: {
    Color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    padding: '24px 16px',
    "& .MuiSelect-select.Mui-disabled": {
      cursor: "not-allowed !important",
      backgroundColor: "#e5e5e5 !important",
    },
  },
  modalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "16px",
    borderTop: "1px solid rgba(148, 157, 178, 0.24)",
    gap: "16px",
    "& .submitButton": {
      "&:hover, &:focus": {
        backgroundColor: "#3f51b5",
      },
    },
  },

  errorText: {
    color: "var(--red)",
    fontSize: "12px",
    margin: "4px 0px 0px 6px",
  },

  pipelineSelect: {
    maxWidth: 230
  },

  titleError: {
    color: "red",
    fontSize: 12,
    position: "absolute",
    bottom: -16,
    minWidth: 'max-content'
  },

  colorPicker: {
    "& input": {
      padding: "0 2px !important",
    },
  },

  stageList: {
    maxHeight: "calc(100vh - 575px)",
    // marginTop: 8,
    paddingBottom: 8,
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarWidth: "thin",
    scrollbarColor: "#888 transparent", // Change color as needed
    "&::-webkit-scrollbar": {
      width: "8px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#888", // Change color as needed
      borderRadius: "6px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      backgroundColor: "#555", // Change color as needed
    },

    "& .inputDelete": {
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
  },

  button: {
    padding: "8px 30px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    textTransform:'uppercase',
    fontWeight: 600,
    fontSize: "13px",
  },

  closeButton: {
    backgroundColor: "#ffffff",
    border: "2px solid #d9dce0",
    color: "#333",
    "&:focus, &:hover": {
      backgroundColor: "#f6f6f6",
    },
  },

  confirmButton: {
    backgroundColor: "#3e50f7",
    color: "#fff",
    border: "2px solid #3e50f7",
    "&:focus, &:hover": {
      border: "2px solid #3e50f7",
      backgroundColor: "#3e50f7",
      transform: "translateY(-1px)",
    },
  },

  disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
    pointerEvents: "none",
  }
}));